import {isCountryNl} from './country.mjs';

// Translations which will be processed by processTranslations task in gulpfile.esm.js
export const translations = {
  FormSearch: {
    'STORE_NO_FOUND': 'storeSearchForm.alert.STORE_NO_FOUND',
    'SEARCH_FAILED': 'storeSearchForm.alert.SEARCH_FAILED',
    'MISSING_ADDRESS': 'storeSearchForm.alert.MISSING_ADDRESS',
    'ADDRESS_NOT_FOUND': 'storeSearchForm.alert.ADDRESS_NOT_FOUND',
  },
  GeoLocation: {
    'PERMISSION_DENIED': 'storeSearchForm.geolocation.alert.PERMISSION_DENIED',
    'POSITION_UNAVAILABLE': 'storeSearchForm.geolocation.alert.POSITION_UNAVAILABLE',
    'TIMEOUT': 'storeSearchForm.geolocation.alert.TIMEOUT',
  },
  OpeningHours: {
    'HEADING': 'storePage.tab.store.opening.heading',
    'TEXT_WEEK_DAY': 'storePage.tab.store.opening.weekDay',
    'TEXT_TIMES': 'storePage.tab.store.opening.times',
    'TEXT_OPEN': 'storePage.tab.store.opening.open',
    'TEXT_CLOSING_SOON': 'storePage.tab.store.opening.closingSoon',
    'TEXT_CLOSED': 'storePage.tab.store.opening.closed',
    'TEXT_CURRENT': 'storePage.tab.store.opening.current',
    'TEXT_TODAY': 'storePage.tab.store.opening.today',
    'CLOSED': 'storePage.tab.store.opening.alert.CLOSED',
    'CLOSED_TEMPORARY': 'storePage.tab.store.opening.alert.CLOSED_TEMPORARY',
  },
  SearchResult: {
    'HEADING': 'storeSearchResult.heading',
    'COPYTEXT': 'storeSearchResult.copytext',
  },
  StoreList: {
    'HEADING': 'storeList.heading',
    'OPEN': 'storeList.opening.open',
    'CLOSED': 'storeList.opening.closed',
    'TEXT_CAMPAIGNS': 'storeList.campaigns',
  }
};

class TranslationLoader {
  currentLanguage = isCountryNl ? 'nl' : 'de';
  cache = {
    de: null,
    nl: null,
  };

  constructor() {
    this.loadTranslations(this.currentLanguage);
  }

  /**
   * Load translations for a specific language
   * @param {string} language - Language code ('de' or 'nl')
   */
  async loadTranslations(language) {
    if (this.cache[language]) {
      return this.cache[language];
    }

    try {
      // Using dynamic import for the JSON files
      const translationsModule = await import(`../../.generated/translations-${language}.json`);

      // Extract the actual translations object from the module
      this.cache[language] = translationsModule.default || {};
    } catch (error) {
      console.error(`Error loading translation file for ${language}:`, error);
    }
  }

  getTranslation(key) {
    if (this.cache[this.currentLanguage][key]) {
      return this.cache[this.currentLanguage][key];
    } else {
      return 'MISSING_TRANSLATION';
    }
  }
}

const defaultTransitionLoader = (new TranslationLoader());

/**
 * Get the translation for a key
 * @param {string} key - Translation key
 * @returns {string} - Translated string or "MISSING_TRANSLATION" if not found
 */
export function getTranslation(key) {
  return defaultTransitionLoader.getTranslation(key);
}
